import { uouButtonClickedEvent } from '../../common/bi-events/uou-events/uou-button-clicked-event';
import uouFileEvents from '../../common/bi-events/uou-events/uou-file-events';
import { uouIncrementPostLikeCountEvent } from '../../common/bi-events/uou-events/uou-increment-post-like-count-event';
import { uouPageOpenedEvent } from '../../common/bi-events/uou-events/uou-page-opened-event';
import { uouPostPageMoreButtonClickedEvent } from '../../common/bi-events/uou-events/uou-post-page-more-button-clicked-event';
import { uouPostPageMoreButtonOptionClickedEvent } from '../../common/bi-events/uou-events/uou-post-page-more-button-option-clicked-event';
import { uouPostPageSocialShareClickedEvent } from '../../common/bi-events/uou-events/uou-post-page-social-share-clicked-event';
import { uouSearchSubmittedEvent } from '../../common/bi-events/uou-events/uou-search-submitted-event';
import { uouTagClickedEvent } from '../../common/bi-events/uou-events/uou-tag-clicked-event';
import { uouActiveTabChangedEvent } from './uou-active-tab-changed-event';
import { uouPostReadingTimeEvent } from './uou-post-reading-time-event';

export const eventMap = {
  ...uouPageOpenedEvent,
  ...uouButtonClickedEvent,
  ...uouIncrementPostLikeCountEvent,
  ...uouFileEvents,
  ...uouTagClickedEvent,
  ...uouPostReadingTimeEvent,
  ...uouActiveTabChangedEvent,
  ...uouSearchSubmittedEvent,
  ...uouPostPageMoreButtonClickedEvent,
  ...uouPostPageMoreButtonOptionClickedEvent,
  ...uouPostPageSocialShareClickedEvent,
};
